import React from 'react';
import { useCompany } from '../../contexts/CompanyContext';
import CompanyLimitsManager from '../../components/admin/CompanyLimitsManager';
import { Gauge } from 'lucide-react';
import { useI18n } from '../../contexts/I18nContext';

const cardStyle: React.CSSProperties = {
  padding: '20px',
  borderRadius: '12px',
  border: '1px solid #e5e7eb',
  backgroundColor: '#fff',
};

const CompanyLimitsManagement: React.FC = () => {
  const { t } = useI18n();
  const { currentCompany, isLoading: isCompanyLoading } = useCompany();

  if (isCompanyLoading) {
    return (
      <div style={{ ...cardStyle, color: '#6b7280' }}>{t('limits.management.loadingCompany')}</div>
    );
  }

  if (!currentCompany) {
    return (
      <div style={{ ...cardStyle, color: '#6b7280' }}>{t('limits.management.selectCompany')}</div>
    );
  }

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '24px' }}>
      <div style={cardStyle}>
        <div style={{ display: 'flex', alignItems: 'flex-start', gap: '12px' }}>
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              width: '44px',
              height: '44px',
              borderRadius: '10px',
              backgroundColor: '#eff6ff',
              color: '#2563eb',
              flexShrink: 0,
            }}
          >
            <Gauge size={22} />
          </div>
          <div>
            <h1 style={{ margin: '0 0 6px 0', fontSize: '22px', fontWeight: 700, color: '#111827' }}>
              Limites de Recursos
            </h1>
            <p style={{ margin: 0, color: '#6b7280', fontSize: '14px', lineHeight: 1.5 }}>
              Configure os limites de usuários, funcionários e clientes para a empresa{' '}
              <strong style={{ color: '#374151' }}>{currentCompany.name}</strong>.
            </p>
            <p style={{ margin: '8px 0 0 0', fontSize: '13px', color: '#9ca3af' }}>{t('limits.management.adminOnly')}</p>
          </div>
        </div>
      </div>

      <CompanyLimitsManager companyId={currentCompany.id} />
    </div>
  );
};

export default CompanyLimitsManagement;
